import { render, staticRenderFns } from "./SubmitPanel.vue?vue&type=template&id=591993af&"
import script from "./SubmitPanel.vue?vue&type=script&lang=js&"
export * from "./SubmitPanel.vue?vue&type=script&lang=js&"
import style0 from "./SubmitPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports